"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _redux = require("redux");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var sockets = {};
var messageQueues = {};
var NORMAL_CLOSE_STATUS = 1000;

var noop = function noop() {};

var noopEventHandlers = {
  onopen: noop,
  onclose: noop,
  onerror: noop,
  onmessage: noop
};

var doWebsocket = function doWebsocket(socketURL, subscribeData, eventHandlers, store, action, options) {
  var socket = sockets[action.type];
  var pullTimeout; // wipe the cached connection and create a new one

  if (socket) socket.close();
  var protocol = typeof options.protocol === 'function' ? options.protocol(store) : undefined;
  var ws = sockets[action.type] = new window.WebSocket(socketURL, protocol);
  var boundEventHandlers = eventHandlers ? (0, _redux.bindActionCreators)(eventHandlers, store.dispatch) : _objectSpread({}, noopEventHandlers);
  var payload = subscribeData || action.payload;

  ws.onopen = function (e) {
    boundEventHandlers.onopen(e);
    if (payload) ws.send(payload);

    if (options.sendInterval) {
      pullTimeout = window.setInterval(function () {
        return ws.send(payload);
      }, options.sendInterval);
    }
  };

  ws.onclose = function (e) {
    console.warn("Websocket connection closing for ".concat(socketURL), e); // eslint-disable-line no-console

    if (pullTimeout) window.clearInterval(pullTimeout);
    boundEventHandlers.onclose(e);

    if (options.reconnect && e.code > NORMAL_CLOSE_STATUS) {
      window.setTimeout(function () {
        return doWebsocket(socketURL, subscribeData, eventHandlers, store, action, options);
      }, 2000);
    }
  };

  ws.onerror = boundEventHandlers.onerror;
  ws.onmessage = boundEventHandlers.onmessage;
};

var enqueueSend = function enqueueSend(action) {
  var _action$payload = action.payload,
      data = _action$payload.data,
      type = _action$payload.type;
  if (!Array.isArray(messageQueues[type])) messageQueues[type] = [];
  messageQueues[type].push(data);
};

if (typeof window !== 'undefined' && window.document && window.document.createElement) {
  // dequeue each message as ws object permits
  window.setInterval(function () {
    for (var _i = 0, _Object$keys = Object.keys(messageQueues); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      var ws = sockets[key];
      if (!ws) continue;
      var datas = messageQueues[key];

      while (datas.length > 0) {
        if (ws.readyState !== 1) break;
        var message = datas.shift();
        ws.send((0, _typeof2.default)(message) === 'object' ? JSON.stringify(message) : message);
      }
    }
  }, 100);
} // heavily influenced by https://www.youfoundron.com/blog/websockets-in-redux-two-approaches/


var createSocketMiddleware = function createSocketMiddleware(socketURL, subscribeData, shouldInstantiate) {
  var shouldSend = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  var eventHandlers = arguments.length > 4 ? arguments[4] : undefined;
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  return function (store) {
    return function (next) {
      return function (action) {
        if (shouldInstantiate(action)) doWebsocket(socketURL, subscribeData, eventHandlers, store, action, options);
        if (shouldSend(action)) enqueueSend(action);
        return next(action);
      };
    };
  };
};

var _default = createSocketMiddleware;
exports.default = _default;